// Em dev: converte URL absoluta em relativa para o proxy funcionar.
// Em prod: retorna o pathname se o host bater com o atual, senão URL completa.
// URLs inválidas (só filename sem path): retorna vazio para exibir fallback.
export function resolveMediaUrl(url: string | null | undefined): string {
  if (!url) return ''
  try {
    const parsed = new URL(url)
    if (parsed.pathname.startsWith('/media/')) {
      return parsed.pathname
    }
    return url
  } catch {
    // URL sem protocolo/path (ex: "uuid.jpeg") — inválida, exibe fallback
    if (url.startsWith('/')) return url
    return ''
  }
}
